module.exports = __webpack_public_path__ + "static/img/top-75-logo.3ab2011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top-75-logo.png
// module id = 7Vus
// module chunks = 0